import { Icon } from '@chakra-ui/react';

const PCMediaObjectIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M17.16,8.51c-0.41-1.58-1.68-2.69-3.31-2.92c-0.03,0-0.05-0.02-0.07-0.03H4.04c-0.3,0.08-0.62,0.12-0.91,0.23
		C1.66,6.36,0.81,7.43,0.57,8.98C0.55,9.15,0.54,9.33,0.54,9.5c0,2.95,0,5.9,0,8.84c0,1.97,1.36,3.58,3.3,3.91
		c0.18,0.03,0.36,0.04,0.54,0.04c2.61,0,4.58,0.01,7.19,0c0.41-0.18,0.53-0.84-0.03-1.03c-2.57,0-4.48-0.09-7.05-0.09
		c-1.41,0-2.54-0.96-2.79-2.34c-0.03-0.17-0.04-0.35-0.04-0.52c0-2.93,0-5.85,0-8.78c0-1.43,0.91-2.54,2.31-2.81
		c0.19-0.04,0.39-0.05,0.58-0.05c2.93,0,5.85,0,8.78,0.01c1.43,0,2.57,0.97,2.8,2.38c0.03,0.18,0.03,0.36,0.03,0.54
		c0,1.44,0,2.89,0,4.33c0,1.46,0,2.92,0,4.38c0,0.98-0.39,1.77-1.18,2.35c-0.49,0.35-1.04,0.51-1.64,0.51c-0.01,0-0.02,0-0.04,0
		c-0.45,0.33-0.47,0.91,0.01,1.12c0.04,0,0.08,0,0.12,0c1.92,0,3.58-1.5,3.82-3.41c0-0.03,0.02-0.06,0.03-0.09V9.06
		C17.24,8.87,17.21,8.69,17.16,8.51z"/>
			<path class="st0" d="M29.46,25.81c-0.22,0.2-0.53,0.25-0.91,0.25c-8.76-0.01-17.51,0-26.27,0c-0.13,0-0.27,0.01-0.39-0.01
		c-0.31-0.05-0.5-0.17-0.5-0.38c0-0.21,0.19-0.34,0.5-0.38c0.12-0.02,0.26-0.01,0.39-0.01c8.76,0,17.51,0,26.27,0
		c0.38,0,0.69,0.05,0.91,0.25C29.46,25.62,29.46,25.72,29.46,25.81z"/>
			<path class="st0" d="M24,22.37c1.46,0,2.92,0,4.38,0c0.08,0,0.16,0,0.25,0c0.36,0.01,0.58,0.17,0.57,0.4
		c-0.01,0.23-0.24,0.39-0.59,0.39c-3.08,0-6.15,0-9.23,0c-0.28,0-0.51-0.08-0.58-0.31c-0.06-0.2,0.04-0.36,0.28-0.44
		c0.14-0.04,0.3-0.04,0.45-0.04C21.02,22.37,22.51,22.37,24,22.37z"/>
			<path class="st0" d="M24,18.86c1.46,0,2.92,0,4.38,0c0.08,0,0.16,0,0.25,0c0.36,0.01,0.58,0.17,0.57,0.4
		c-0.01,0.23-0.24,0.39-0.59,0.39c-3.08,0-6.15,0-9.23,0c-0.28,0-0.51-0.08-0.58-0.31c-0.06-0.2,0.04-0.36,0.28-0.44
		c0.14-0.04,0.3-0.04,0.45-0.04C21.02,18.86,22.51,18.86,24,18.86z"/>
			<path class="st0" d="M24,15.82c1.46,0,2.92,0,4.38,0c0.08,0,0.16,0,0.25,0c0.36,0.01,0.58,0.17,0.57,0.4
		c-0.01,0.23-0.24,0.39-0.59,0.39c-3.08,0-6.15,0-9.23,0c-0.28,0-0.51-0.08-0.58-0.31c-0.06-0.2,0.04-0.36,0.28-0.44
		c0.14-0.04,0.3-0.04,0.45-0.04C21.02,15.82,22.51,15.82,24,15.82z"/>
			<path class="st0" d="M24,12.42c1.46,0,2.92,0,4.38,0c0.08,0,0.16,0,0.25,0c0.36,0.01,0.58,0.17,0.57,0.4
		c-0.01,0.23-0.24,0.39-0.59,0.39c-3.08,0-6.15,0-9.23,0c-0.28,0-0.51-0.08-0.58-0.31c-0.06-0.2,0.04-0.36,0.28-0.44
		c0.14-0.04,0.3-0.04,0.45-0.04C21.02,12.42,22.51,12.42,24,12.42z"/>
			<path class="st0" d="M24,8.67c1.46,0,2.92,0,4.38,0c0.08,0,0.16,0,0.25,0c0.36,0.01,0.58,0.17,0.57,0.4
		c-0.01,0.23-0.24,0.39-0.59,0.39c-3.08,0-6.15,0-9.23,0c-0.28,0-0.51-0.08-0.58-0.31c-0.06-0.2,0.04-0.36,0.28-0.44
		c0.14-0.04,0.3-0.04,0.45-0.04C21.02,8.67,22.51,8.67,24,8.67z"/>
			<path class="st0" d="M24,5.56c1.46,0,2.92,0,4.38,0c0.08,0,0.16,0,0.25,0c0.36,0.01,0.58,0.17,0.57,0.4
		c-0.01,0.23-0.24,0.39-0.59,0.39c-3.08,0-6.15,0-9.23,0c-0.28,0-0.51-0.08-0.58-0.31c-0.06-0.2,0.04-0.36,0.28-0.44
		c0.14-0.04,0.3-0.04,0.45-0.04C21.02,5.56,22.51,5.56,24,5.56z"/>
			<g>
				<path class="st0" d="M11.11,8.67c-0.9,0-1.64,0.74-1.64,1.64c0,0.91,0.73,1.64,1.63,1.65c0.92,0,1.66-0.74,1.66-1.65
			C12.76,9.41,12.01,8.66,11.11,8.67z M11.12,11.36c-0.58,0-1.05-0.47-1.05-1.05c0-0.58,0.47-1.05,1.05-1.05s1.05,0.47,1.05,1.05
			C12.17,10.89,11.7,11.36,11.12,11.36z"/>
				<g>
					<path class="st0" d="M11.07,14.93c-0.43,0.01-0.41,0-0.53-0.43c-0.2-0.77-0.69-1.26-1.44-1.41c-0.77-0.15-1.42,0.12-1.86,0.81
				c-0.16,0.26-0.3,0.34-0.61,0.27c-0.75-0.17-1.5,0.38-1.69,1.15c-0.01,0.04-0.01,0.07-0.02,0.11c-0.03,0.13-0.05,0.29-0.23,0.25
				c-0.15-0.04-0.11-0.2-0.1-0.31c0.1-0.94,1.05-1.68,2.01-1.55c0.18,0.02,0.28-0.02,0.38-0.17c0.53-0.73,1.25-1.05,2.11-0.9
				c0.86,0.14,1.42,0.7,1.71,1.55c0.07,0.21,0.15,0.3,0.37,0.31c1.04,0.02,1.9,0.86,2.01,1.96c0.11,1.07-0.56,2.09-1.55,2.36
				c-0.14,0.04-0.28,0.07-0.42,0.09c-0.12,0.02-0.26,0.01-0.28-0.14c-0.03-0.17,0.12-0.18,0.24-0.2c0.51-0.08,0.98-0.27,1.31-0.72
				c0.45-0.61,0.53-1.28,0.21-1.97C12.38,15.28,11.81,14.95,11.07,14.93z"/>
					<path class="st0" d="M11.16,19.2c-0.31,0-0.37-0.23-0.39-0.31c-0.02-0.13,0.02-0.21,0.06-0.26c0.08-0.11,0.22-0.13,0.31-0.15
				l0.02,0c0.56-0.09,0.92-0.28,1.18-0.64c0.41-0.57,0.48-1.17,0.19-1.78c-0.28-0.6-0.78-0.92-1.46-0.95
				c-0.49,0.01-0.57-0.05-0.7-0.54l-0.01-0.04c-0.19-0.71-0.62-1.14-1.29-1.27C8.37,13.14,7.79,13.39,7.4,14
				c-0.18,0.29-0.38,0.45-0.81,0.35c-0.63-0.14-1.3,0.32-1.46,1.01c0,0.01-0.01,0.03-0.01,0.04c0,0.02-0.01,0.05-0.01,0.07
				L5.11,15.5c-0.02,0.11-0.06,0.25-0.19,0.33c-0.05,0.03-0.14,0.06-0.26,0.03c-0.3-0.08-0.26-0.38-0.24-0.48c0-0.01,0-0.03,0-0.04
				c0.05-0.49,0.33-0.96,0.74-1.29c0.43-0.34,0.97-0.49,1.48-0.43c0.11,0.01,0.14,0,0.21-0.09c0.58-0.79,1.37-1.13,2.3-0.98
				c0.9,0.15,1.54,0.73,1.85,1.68c0.06,0.17,0.08,0.17,0.2,0.18c1.13,0.02,2.07,0.94,2.19,2.13c0.12,1.17-0.61,2.27-1.68,2.56
				c-0.15,0.04-0.3,0.07-0.45,0.09C11.23,19.19,11.19,19.2,11.16,19.2z M10.81,14.73c0.03,0.01,0.09,0.01,0.16,0.01
				c-0.1-0.04-0.17-0.09-0.22-0.17C10.78,14.65,10.8,14.71,10.81,14.73z M6.77,14c0.11,0.01,0.17-0.01,0.24-0.09
				C6.94,13.96,6.86,13.99,6.77,14z"/>
				</g>
			</g>
		</g>

	</Icon>
);

export default PCMediaObjectIcon;
